import(/* webpackMode: "eager", webpackExports: ["FadeInUp"] */ "/vercel/path0/frontend/src/components/animations/FadeInUp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageTransition"] */ "/vercel/path0/frontend/src/components/layout/PageTransition.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/vercel/path0/frontend/src/components/services/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceCTA"] */ "/vercel/path0/frontend/src/components/services/ServiceCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceFeatures"] */ "/vercel/path0/frontend/src/components/services/ServiceFeatures.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceHero"] */ "/vercel/path0/frontend/src/components/services/ServiceHero.tsx");
